let util = {
    // 按全名排序
    getNameSortedTypes(){
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.expense_type_name_sorted_types).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    // 最后一代, 包含废弃的
    getLastGenerationTypes(){
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.expense_type_last_generation_types).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    // 使用中的最后一代
    getUsedLastGenerationTypes(){
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.expense_type_used_last_generation_types).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
};

export default util;
